import * as React from 'react';

import { setIsLoading as setIsLoadingAction } from './actions';
import { store } from './store';
import { useNavigate } from 'react-router-dom';

export function useAppContext() {
    const context = React.useContext(store);
    const navigate = useNavigate();

    if (context === undefined)
        throw new Error('useAppContext must be used within an AppContextProvider');

    const setIsLoading = (isLoading: boolean) =>
        context.dispatch(setIsLoadingAction(isLoading));

    const navigateToLandingPage = () =>
        navigateTo('/');

    const navigateToAddressPage = (code: string) =>
        navigateTo(`/${encodeURIComponent(code)}/address`);

    const navigateToPaymentPage = (code: string) =>
        navigateTo(`/${encodeURIComponent(code)}/payment`);

    const navigateToPaymentErrorPage = (code: string) =>
        navigateTo(`/${encodeURIComponent(code)}/payment/error`);

    const navigateToPaymentCompletePage = (code: string) =>
        navigateTo(`/${encodeURIComponent(code)}/payment/complete`);

    const navigateToPaymentExpiredPage = (code: string) =>
        navigateTo(`/${encodeURIComponent(code)}/payment/expired`);

    const navigateTo = (path: string) => {
        console.log('Navigating to', path);
        navigate(path,);
    }

    return {
        isLoading: context.state.isLoading,
        navigateToLandingPage,
        navigateToAddressPage,
        navigateToPaymentPage,
        navigateToPaymentErrorPage,
        navigateToPaymentCompletePage,
        navigateToPaymentExpiredPage,
        setIsLoading,
    } as const;
};